import { createQS } from "utils";
import {
  FETCH_FAILED,
  FETCH_WIDGET_DATA,
  PUSH_NOTIFICATION,
  REMOVE_MESSAGE,
  UPDATE_WIDGET_DATA,
  UPDATE_WIDGET_FROM_TO_DATES
} from "./types";
import { API, Auth } from "aws-amplify";
import { setColor } from "../../views/Dashboard/dashboard/ColorPalette";
import { hexToRgb } from "@material-ui/core/styles";
import { hexToRgbA } from "../../views/Dashboard/dashboard/common";

import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()
const config = require("app_configuration").CONFIGURATION[environment];

export const fetchWidgetDataV2 = props => async (dispatch, getState) => {
  const state = getState();

  let data = {
    queryStringParameters: {
      ApiCall: "dashboard.summary",
      QueryData: createQS({
        start_date: props.startDate,
        end_date: props.endDate,
        tenant: state.auth.cognitoUser.attributes["custom:tenant"]
      })
    },
    headers: {
      Authorization: state.auth.cognitoUser.signInUserSession.idToken.jwtToken
    }
  };
  try {
    const response = await API.get(config.AWS_API_NAME, "dashboard", data);
    dispatch({
      type: FETCH_WIDGET_DATA,
      payload: response.data
    });
  } catch (err) {
    if (err.response.status == 500 || err.response.status == 401) {
      dispatch({
        type: FETCH_FAILED
      });
    }
  }
};

export const updateWidgetData = (props, updatedData, payload) => async (dispatch, getState) => {
  const state = getState();
  console.log("------------", props, updatedData, payload);
  let data = {
    queryStringParameters: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "ReviewMissingUtterances",
      Params: payload
    }
  };
  const response = await API.get(config.AWS_API_NAME, "dashboard", data);
  console.log("UPDATE_WIDGET_DATA", { chart: props.Chart, response: response, data: updatedData });
  dispatch({
    type: UPDATE_WIDGET_DATA,
    payload: { chart: props.Chart, response: response, data: updatedData }
  });

  if (response.status === "success" && response.code === 200) {
    const dataLen = updatedData.length;
    dispatch({
      type: PUSH_NOTIFICATION,
      payload: {
        message:
          "Successfully marked (" + dataLen + ") " + (dataLen > 1 ? "utterances " : "utterance ") + "as Reviewed.",
        type: "success"
      }
    });
  } else {
    dispatch({
      type: PUSH_NOTIFICATION,
      payload: {
        message: response.message,
        type: "error"
      }
    });
  }
};

export const updateFromToDate = props => async (dispatch, getState) => {
  dispatch({
    type: UPDATE_WIDGET_FROM_TO_DATES,
    payload: props
  });
};
